import { createContext, use } from 'react'

export interface PunchoutContextType {
  sessionId: string
  isPreparingCXMLData: boolean
  clearShoppingCartSession: () => void
  renewShoppingCartSession: () => void
  onSubmitPunchoutData: () => void
  onReturnToProcurement: () => void
}

// const sessionCookieKey = "";

// export const getSessionCookieKey = () => sessionCookieKey;

export const PunchoutContext = createContext<PunchoutContextType | null>(null)

export const usePunchoutContext = () => {
  const punchOutContext = use(PunchoutContext)

  if (punchOutContext === undefined) {
    throw new Error(
      'usePunchoutContext must be used within a PunchoutProvider',
    )
  }

  return punchOutContext
}
